import React, { useState } from 'react';
import './Comment.css';
import AddCommentForm from '../AddCommentForm/AddCommentForm';
import { IoAdd, IoRemove, IoArrowUndoSharp } from "react-icons/io5";
import { FormatDate } from '../../helpers/FormatDate';

const Comment = ({ clipId, comment, fetchReplies, onReplySubmit }) => {
    const [replies, setReplies] = useState([]);
    const [showReplies, setShowReplies] = useState(false);
    const [isReplying, setIsReplying] = useState(false);

    const toggleReplies = async () => {
        if (!showReplies && replies.length === 0) {
            fetchAndUpdateReplies();
        }
        setShowReplies(!showReplies);
    };

    const toggleIsReplying = () => {
        setIsReplying(!isReplying);
    };

    const fetchAndUpdateReplies = async () => {
        const fetchedReplies = await fetchReplies(comment.id);
        fetchedReplies.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        setReplies(fetchedReplies);
    };

    const handleReplySubmit = async (text) => {
        await onReplySubmit(clipId, comment.id, text); // Assuming this function returns a promise
        comment.num_replies += 1; // Update the number of replies in the UI
        setIsReplying(false); // Hide the reply form after submission
        fetchAndUpdateReplies();
    };

    return (
        <div>
            <div className='commentTextContainer'>
                <button className={comment.num_replies > 0 ? 'toggleRepliesButton' : 'toggleRepliesButtonDisabled'} onClick={toggleReplies}>{showReplies ? <IoRemove size={15} /> : <IoAdd size={15} />}</button>
                <p className='commentText'>{comment.comment + ' '}
                    <span className='commentTimestamp'>{FormatDate(comment.created_at, 'PPpp')}</span>
                    <button className='addReplyButton' onClick={toggleIsReplying}><IoArrowUndoSharp size={15} /> Reply ({comment.num_replies})</button>
                </p>
            </div>
            {isReplying &&
                <div className='addReplyForm'>
                    <AddCommentForm onSubmit={handleReplySubmit} placeholder="Write a reply..." maxLength={500} />
                </div>
            }
            {showReplies && (
                <>
                    {replies.map((reply) => (
                        <div key={reply.id} style={{ marginLeft: '20px' }}>
                            <Comment clipId={clipId} comment={reply} fetchReplies={fetchReplies} onReplySubmit={onReplySubmit} />
                        </div>
                    ))}
                </>
            )}
        </div>
    );
};

export default Comment;
